import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={34}
            height={34}
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <rect width={34} height={34} rx={17} fill={props.isHover ? '#B42318' : theme["#0D968F"]} />
        <path transform="translate(5 5)" fill={props.isHover ? '#B42318' : theme["#0D968F"]} d="M0 0H24V24H0z" />
        <path
            d="M15.379 12.953L11.332 17l4.047 4.047M22.67 17H11.45"
            stroke="#fff"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        </svg>
    )
}

export default SvgComponent
